import axios from "axios"
import { ref } from '@vue/composition-api';

export default function useSolutionSelector (){

    const solutionsAreas = ref([]);

    function getAreaSolutions(){
        axios.get('/actions/misc.cfc?method=getAreaSolutions').then(function(response){
            var groupedSolutions = {};
            for (let solution of response.data){
                if(!groupedSolutions[solution.AREAID]){
                    groupedSolutions[solution.AREAID] = {
                        name: solution.AREA_NAME,
                        id: solution.AREAID,
                        solutions: [solution],
                        icon: solution.AREA_ICON
                    }
                } else {
                    groupedSolutions[solution.AREAID].solutions.push(solution);
                }
            }
            solutionsAreas.value = groupedSolutions;
        });
    }

    return {
        getAreaSolutions,
        solutionsAreas
    }
}
